export default __webpack_public_path__ + "static/media/activity_course_master_course_avatar.2ac38f7c.svg";